import { pdfService } from '@/services/pdf.service';
import { DispatchNote, Invoice } from '@/types/order';
import { PDFRequest, PrintContract } from '@/types/pdf';
import { useMutation } from '@tanstack/react-query';

export const usePrintContract = () => {
  return useMutation(async (data: PrintContract) => {
    const pdfBlob: any = await pdfService.printContract(data);
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return pdfUrl;
  });
};

export const useDispatchNotePDF = () => {
  return useMutation(async (data: PDFRequest<DispatchNote[]>) => {
    const pdfBlob: any = await pdfService.dispatchNote(data);
    const blobType = pdfBlob?.type?.split('/')[1];
    return {
      url: URL.createObjectURL(pdfBlob),
      type: blobType,
    };
  });
};

export const useDownloadQuotation = () => {
  return useMutation(async (data: any) => {
    const pdfBlob: any = await pdfService.downloadQuotation(data);
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return pdfUrl;
  });
};

export const useInvoicePDF = () => {
  return useMutation(async (data: PDFRequest<Invoice[]>) => {
    const pdfBlob: any = await pdfService.invoice(data);
    const blobType = pdfBlob?.type?.split('/')[1];
    return {
      url: URL.createObjectURL(pdfBlob),
      type: blobType,
    };
  });
};
export const useConsolidatedInvoice = () => {
  return useMutation(async (data: any) => {
    const pdfBlob: any = await pdfService.invoice(data);
    const blobType = pdfBlob?.type?.split('/')[1];
    return {
      url: URL.createObjectURL(pdfBlob),
      type: blobType,
    };
  });
};
export const useMutationPaymentInvoice = () => {
  return useMutation(async (data: any) => {
    const pdfBlob: any = await pdfService.paymentInvoice(data);
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return pdfUrl;
  });
};
export const useMutationQTPPdf = () => {
  return useMutation(async (data: any) => {
    const pdfBlob: any = await pdfService.qtpPDF(data);
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return pdfUrl;
  });
};
